import { IconShieldCheck } from '@tabler/icons-react';

const PrivacyPolicy = () => {
    return (
        <div className="container-fluid py-5" id="privacy-policy">
            <div className="container py-5">
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        
                        <div className="text-center mb-5">
                            <IconShieldCheck stroke={1.5} size={64} className="text-danger mb-3" />
                            <h1 className="heading mb-3">Politica de Confidentialitate</h1>
                        </div>

                        <div className="content">
                            
                            <section className="mb-5">
                                <h3 className="heading text-danger mb-3">1. Introducere</h3>
                                <p>
                                    MISU LZR MOBAUTO S.R.L. ("noi", "nostru" sau "compania") respecta confidentialitatea vizitatorilor site-ului nostru web 
                                    <strong> www.piesemisu.ro</strong>. Aceasta Politica de Confidentialitate explica modul in care colectam, utilizam, 
                                    divulgam si protejam informatiile dvs. personale in conformitate cu Regulamentul General privind Protectia Datelor (GDPR) 
                                    si legislatia romana aplicabila.
                                </p>
                            </section>

                            <section className="mb-5">
                                <h3 className="heading text-danger mb-3">2. Informatii pe care le Colectam</h3>
                                <p>Colectam urmatoarele tipuri de informatii:</p>
                                <ul>
                                    <li><strong>Informatii de contact:</strong> nume, adresa de email, numar de telefon</li>
                                    <li><strong>Informatii despre vehicul:</strong> marca, model, motor, VIN (seria de sasiu)</li>
                                    <li><strong>Informatii tehnice:</strong> adresa IP, tip de browser, sistem de operare</li>
                                    <li><strong>Date de utilizare:</strong> pagini vizitate, timp petrecut pe site, interactiuni</li>
                                    <li><strong>Cookies si tehnologii similare:</strong> pentru imbunatatirea experientei utilizatorului</li>
                                </ul>
                            </section>

                            <section className="mb-5">
                                <h3 className="heading text-danger mb-3">3. Cum Utilizam Informatiile</h3>
                                <p>Utilizam informatiile colectate pentru urmatoarele scopuri:</p>
                                <ul>
                                    <li>Procesarea solicitarilor de oferte si comenzi</li>
                                    <li>Verificarea compatibilitatii pieselor auto folosind seria de sasiu</li>
                                    <li>Comunicare cu clientii si furnizare de asistenta</li>
                                    <li>Imbunatatirea serviciilor si experientei pe site</li>
                                    <li>Trimiterea de newsletters si oferte speciale (doar cu acordul dvs.)</li>
                                    <li>Respectarea obligatiilor legale si fiscale</li>
                                    <li>Prevenirea fraudelor si asigurarea securitatii</li>
                                </ul>
                            </section>

                            <section className="mb-5">
                                <h3 className="heading text-danger mb-3">4. Baza Legala pentru Prelucrarea Datelor</h3>
                                <p>Prelucram datele dvs. personale pe baza urmatoarelor temeiuri juridice:</p>
                                <ul>
                                    <li><strong>Consimtamant:</strong> pentru trimiterea de newsletters si comunicari de marketing</li>
                                    <li><strong>Executarea contractului:</strong> pentru procesarea comenzilor si furnizarea de servicii</li>
                                    <li><strong>Interes legitim:</strong> pentru imbunatatirea serviciilor si securitatea site-ului</li>
                                    <li><strong>Obligatii legale:</strong> pentru respectarea legislatiei fiscale si comerciale</li>
                                </ul>
                            </section>

                            <section className="mb-5">
                                <h3 className="heading text-danger mb-3">5. Partajarea Informatiilor</h3>
                                <p>Nu vindem, nu comercializam si nu inchiriem informatiile dvs. personale catre terti. Putem partaja informatii cu:</p>
                                <ul>
                                    <li><strong>Furnizori de piese auto:</strong> pentru verificarea disponibilitatii si preturilor</li>
                                    <li><strong>Furnizori de servicii:</strong> hosting, email, procesare plati</li>
                                    <li><strong>Autoritatile competente:</strong> cand este necesar conform legii</li>
                                </ul>
                                <p>Toti partenerii nostri sunt obligati contractual sa protejeze confidentialitatea datelor dvs.</p>
                            </section>

                            <section className="mb-5">
                                <h3 className="heading text-danger mb-3">6. Cookies si Tehnologii de Urmarire</h3>
                                <p>
                                    Utilizam cookies pentru a imbunatati experienta dvs. pe site. Cookies-urile sunt fisiere mici de text 
                                    stocate pe dispozitivul dvs. care ne ajuta sa:
                                </p>
                                <ul>
                                    <li>Retinem preferintele dvs.</li>
                                    <li>Analizam traficul pe site (Google Analytics)</li>
                                    <li>Personalizam continutul si publicitatea</li>
                                </ul>
                                <p>
                                    Puteti controla si sterge cookies-urile din setarile browser-ului dvs. Totusi, dezactivarea cookies-urilor 
                                    poate afecta functionalitatea site-ului.
                                </p>
                            </section>

                            <section className="mb-5">
                                <h3 className="heading text-danger mb-3">7. Drepturile Dvs. (GDPR)</h3>
                                <p>In conformitate cu GDPR, aveti urmatoarele drepturi:</p>
                                <ul>
                                    <li><strong>Dreptul de acces:</strong> puteti solicita o copie a datelor personale pe care le detinem</li>
                                    <li><strong>Dreptul la rectificare:</strong> puteti corecta datele inexacte sau incomplete</li>
                                    <li><strong>Dreptul la stergere:</strong> puteti solicita stergerea datelor ("dreptul de a fi uitat")</li>
                                    <li><strong>Dreptul la restrictionare:</strong> puteti limita prelucrarea datelor dvs.</li>
                                    <li><strong>Dreptul la portabilitate:</strong> puteti primi datele intr-un format structurat</li>
                                    <li><strong>Dreptul la opozitie:</strong> puteti refuza prelucrarea datelor pentru anumite scopuri</li>
                                    <li><strong>Retragerea consimtamantului:</strong> puteti retrage oricand consimtamantul acordat</li>
                                </ul>
                                <p>
                                    Pentru exercitarea acestor drepturi, va rugam sa ne contactati la <strong>misupiese@gmail.com</strong> 
                                    sau <strong>+40 723 531 203</strong>.
                                </p>
                            </section>

                            <section className="mb-5">
                                <h3 className="heading text-danger mb-3">8. Securitatea Datelor</h3>
                                <p>
                                    Implementam masuri de securitate tehnice si organizatorice adecvate pentru protejarea datelor dvs. impotriva 
                                    accesului neautorizat, pierderii, distrugerii sau divulgarii. Acestea includ:
                                </p>
                                <ul>
                                    <li>Criptarea datelor in tranzit (SSL/TLS)</li>
                                    <li>Acces restrictionat la date personale</li>
                                    <li>Monitorizarea si auditarea regulata a sistemelor</li>
                                    <li>Formarea personalului in domeniul protectiei datelor</li>
                                </ul>
                            </section>

                            <section className="mb-5">
                                <h3 className="heading text-danger mb-3">9. Pastrarea Datelor</h3>
                                <p>
                                    Pastram datele dvs. personale doar pe durata necesara pentru indeplinirea scopurilor pentru care au fost colectate, 
                                    sau conform cerintelor legale. In general:
                                </p>
                                <ul>
                                    <li>Datele de contact pentru clienti activi: pana la 3 ani de la ultima interactiune</li>
                                    <li>Datele despre comenzi: 5-10 ani (conform obligatiilor fiscale)</li>
                                    <li>Date de marketing: pana la retragerea consimtamantului</li>
                                </ul>
                            </section>

                            <section className="mb-5">
                                <h3 className="heading text-danger mb-3">10. Transferuri Internationale de Date</h3>
                                <p>
                                    Datele dvs. sunt prelucrate in principal in Romania/Uniunea Europeana. Daca transferam date in afara UE, 
                                    ne asiguram ca sunt implementate garantii adecvate conform GDPR (ex: clauze contractuale standard).
                                </p>
                            </section>

                            <section className="mb-5">
                                <h3 className="heading text-danger mb-3">11. Confidentialitatea Copiilor</h3>
                                <p>
                                    Site-ul nostru nu este destinat copiilor sub 16 ani. Nu colectam in mod deliberat informatii personale 
                                    de la copii. Daca aflam ca am colectat date de la un copil, vom sterge imediat aceste informatii.
                                </p>
                            </section>

                            <section className="mb-5">
                                <h3 className="heading text-danger mb-3">12. Modificari ale Politicii de Confidentialitate</h3>
                                <p>
                                    Ne rezervam dreptul de a actualiza aceasta Politica de Confidentialitate periodic. Modificarile importante 
                                    vor fi comunicate prin intermediul site-ului sau prin email. Data ultimei actualizari este afisata in 
                                    partea de sus a acestei pagini.
                                </p>
                            </section>

                            <section className="mb-5">
                                <h3 className="heading text-danger mb-3">13. Contact si Plangeri</h3>
                                <p><strong>Operator de date:</strong> MISU LZR MOBAUTO S.R.L.</p>
                                <p><strong>Adresa:</strong> Str. Schitului 14, 127187, Buda-Cracunesti, Buzau, Romania</p>
                                <p><strong>Email:</strong> misupiese@gmail.com</p>
                                <p><strong>Telefon:</strong> +40 723 531 203</p>
                                <p className="mt-3">
                                    Daca considerati ca drepturile dvs. privind protectia datelor au fost incalcate, aveti dreptul de a 
                                    depune o plangere la Autoritatea Nationala de Supraveghere a Prelucrarii Datelor cu Caracter Personal (ANSPDCP):
                                </p>
                                <p>
                                    <strong>ANSPDCP:</strong> B-dul G-ral. Gheorghe Magheru 28-30, Sector 1, Bucuresti<br/>
                                    <strong>Website:</strong> <a href="https://www.dataprotection.ro" target="_blank" rel="noopener noreferrer">www.dataprotection.ro</a>
                                </p>
                            </section>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
